import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@portals/environments';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, finalize, firstValueFrom, mergeMap, Observable, of, pipe, repeat, takeUntil } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Pipe({
	name: 'thumbnail',
})
export class ThumbnailPipe implements PipeTransform {
	constructor(private http: HttpClient, private _sanitizer: DomSanitizer) {}

	transform(row: any, type?: string): Observable<string> {
		// console.log("HERE IS A ROW", row)
		if (['report', 'police_report', 'text'].indexOf(row.type) > -1) return of('assets/images/report-thumb.png');
		else if (row.audioOnly == true) return of('assets/images/mic.png');
		else {
			return this.http
				.head(`${environment.s3ThumbnailBucket}${row.uuid}_${type}.png`, {
					headers: {
						'x-skip-interceptor': 'true',
						'Cache-Control': 'no-cache',
						Expires: 'Mon, 01 Jan 1990 00:00:00 GMT',
					},
				})
				.pipe(
					map(() => {
						return `${environment.s3ThumbnailBucket}${row.uuid}_${type}.png`;
					}),
					catchError((err) => {
						if (new Date().getTime() - new Date(row?.createdAt).getTime() >= 450000) return of('assets/images/video-thumb-small.png');
						else return of('assets/images/loading.gif');
					}),
					repeat({ count: 4, delay: 2500 })
				);
		}
	}
}
